export default __webpack_public_path__ + "static/media/jumping.a102eb60.png";